import { audioState, updateAudioSettings } from './state';

const pct = (v: number): number => Math.round(v * 100);
const fromPct = (e: Event): number => Math.min(1, Math.max(0, Number((e.currentTarget as HTMLInputElement).value) / 100));

/** Réglages du Hub : volumes Musique et Effets (0 à 100), case Muet. Mémorisés dans localStorage (`rogfus.audio`). */
export function AudioSettingsPanel() {
  const s = audioState.settings.value;
  return (
    <fieldset class="audio-settings">
      <legend>Son</legend>
      <label class="audio-row"><span>Musique</span><input type="range" min={0} max={100} step={5} value={pct(s.music)} aria-label="Musique" onInput={(e) => { updateAudioSettings({ music: fromPct(e) }); }} /><b>{pct(s.music)}</b></label>
      <label class="audio-row"><span>Effets</span><input type="range" min={0} max={100} step={5} value={pct(s.sfx)} aria-label="Effets" onInput={(e) => { updateAudioSettings({ sfx: fromPct(e) }); }} /><b>{pct(s.sfx)}</b></label>
      <label class="audio-row audio-mute"><input type="checkbox" checked={s.muted} aria-label="Muet" onChange={(e) => { updateAudioSettings({ muted: (e.currentTarget as HTMLInputElement).checked }); }} /><span>Muet</span></label>
    </fieldset>
  );
}

/** Bouton muet rapide du HUD. */
export function MuteButton() {
  const muted = audioState.settings.value.muted;
  return (
    <button class="hud-mute" aria-pressed={muted} aria-label={muted ? 'Rétablir le son' : 'Couper le son'} title={muted ? 'Rétablir le son' : 'Couper le son'}
      onMouseDown={(e) => e.preventDefault()} onClick={() => { updateAudioSettings({ muted: !muted }); }}>
      {muted ? '🔇' : '🔊'}
    </button>
  );
}
